/**
 * DataBridge logo mark — redesigned suspension bridge icon.
 * 3 suspenders, cubic-bezier arch, balanced proportions.
 */
export function BridgeIcon({
  size = 20,
  className = "",
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      width={size}
      height={Math.round(size * 0.78)}
      viewBox="0 0 36 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Left tower */}
      <rect x="0" y="10" width="5" height="18" rx="1.75" fill="currentColor" />
      {/* Right tower */}
      <rect x="31" y="10" width="5" height="18" rx="1.75" fill="currentColor" />

      {/* Main arch — cubic bezier for a smooth, natural curve */}
      <path
        d="M2.5 10 C2.5 1 33.5 1 33.5 10"
        stroke="currentColor"
        strokeWidth="2.75"
        strokeLinecap="round"
        fill="none"
      />

      {/* Left suspender */}
      <line x1="10.5" y1="5" x2="10.5" y2="26" stroke="currentColor" strokeWidth="1.5" strokeOpacity="0.4" strokeLinecap="round" />
      {/* Center suspender (tallest — touches arch peak) */}
      <line x1="18" y1="1" x2="18" y2="26" stroke="currentColor" strokeWidth="1.5" strokeOpacity="0.4" strokeLinecap="round" />
      {/* Right suspender */}
      <line x1="25.5" y1="5" x2="25.5" y2="26" stroke="currentColor" strokeWidth="1.5" strokeOpacity="0.4" strokeLinecap="round" />

      {/* Road deck */}
      <rect x="0" y="24.5" width="36" height="3" rx="1.5" fill="currentColor" fillOpacity="0.28" />
    </svg>
  )
}
